import { render, staticRenderFns } from "./repairDetail.vue?vue&type=template&id=177c055c&scoped=true&"
import script from "./repairDetail.vue?vue&type=script&lang=js&"
export * from "./repairDetail.vue?vue&type=script&lang=js&"
import style0 from "./repairDetail.vue?vue&type=style&index=0&id=177c055c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177c055c",
  null
  
)

export default component.exports